module.exports = __webpack_public_path__ + "img/stckapp.d9e79862.png";